<template>
  <div class="w-full flex items-center relative justify-center">
    <div class="relative w-full" v-if="!value">
      <button v-bind="$attrs" type="button" class="bg-coral-400 px-4 h-12 rounded-md text-white font-semibold w-full" @click="browse">{{ __("Add media")}}</button>
    </div>

    <div class="form-input p-0 flex flex-col max-w-104 max-h-full" :class="{ error: errors.length }">
      <input ref="file" type="file" accept="image/*,video/*" class="hidden" @change="change">

      <div class="flex-shrink-0 mx-auto">
        <img src="" alt="" ref="preview" class="mb-2 h-40 w-full object-contain" v-if="value">
        <div class="text-center break-all" v-if="value">{{ value.name }} <span class="text-grey-dark text-sm">({{ filesize(value.size) }})</span></div>
      </div>

      <div v-if="value" class="flex flex-col p-2 mt-4 items-center">
        <div>
          <button type="button" class="btn-secondary outlined" @click="remove">{{ __("Cancel") }}</button>
        </div>

        <div class="mt-2">
          <button type="submit" :disabled="loading" class="flex items-center text-xl px-4 py-3 rounded-lg bg-coral-400 border-2 border-coral-400 hover:bg-coral-300 text-white">
            <span v-if="loading" class="spinner mr-2"></span>
            {{ __("Save") }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
  </div>
</template>

<script>
  import Icon from '@/Shared/Icon';

  export default {
    props: {
      loading: Boolean,
      value: File,
      errors: {
        type: Array,
        default: () => [],
      },
    },
    components: {Icon},
    watch: {
      value(value) {
        if (!value) {
          this.$refs.file.value = '';
          this.$refs.preview.src = '';
        }
      },
    },
    methods: {
      filesize(size) {
        let i = Math.floor(Math.log(size) / Math.log(1024));
        return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
      },
      browse() {
        this.$refs.file.click()
      },
      change(e) {
        let file = e.target.files[0];
        let reader = new FileReader();

        reader.onloadend = () => {
          this.$refs.preview.src = reader.result;
        };

        if (file) {
          reader.readAsDataURL(file);
        }

        this.$emit('input', e.target.files[0])
      },
      remove() {
        this.$emit('input', null)
      },
    },
  }
</script>
